import MyProfileContainer from "../components/MyProfileContainer";
import ProfileCard from "../components/molicules/ProfileCard";
import { InputElement } from "../components/molicules/Input";
import { useDispatch } from "react-redux";
import SelectBox from "./molicules/SelectBox";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
//
import NotifyAddTocart from "components/NotifyAddTocart";
//
import Button from "@mui/material/Button";
import useUpdateProfile from "../hooks/useUpdateProfile";
import { InputFile } from "./molicules/InputFile";
import { updateProfile } from "app/auth/authSlice";
import { CircularProgress } from "@mui/material";
import { useUploadImageMutation } from "app/slices/mutationSlices/enquiry/stateDistSlice";

export const notifyAddTocart = (message) => {
  toast.custom((t) => <NotifyAddTocart show={t.visible} message={message} />, {
    position: "top-right",
    id: "nc-product-notify",
    duration: 3000,
  });
};

//
const MyProfile = () => {
  const dispatch = useDispatch();
  //
  const [uploadImage, { isLoading: isLoadingPic }] = useUploadImageMutation();
  //
  //
  const { profile, loading } = useSelector((state) => state.authSliceReducer);
  let { profile_img, full_name, email, mobile_number } = profile.data;
  ///

  const { handleChange, profileformdata, handleUpload } = useUpdateProfile({
    uploadImage,
  });
  //
  const HandleSubmit = (e) => {
    e.preventDefault();
    //
    dispatch(updateProfile(profileformdata));
  };
  //

  ////
  const ItemsMenuCusType = [
    { entity: "Individual" },
    { entity: "Dealer" },
    { entity: "Bussiness" },
  ];

  const ItemsMenuGst = [{ entity: "Registerd" }, { entity: "Non-Registered" }];

  //
  return (
    <>
      <form onSubmit={HandleSubmit} autoComplete="off">
        <div className="form-container mb-6 ">
          <MyProfileContainer title="" pic={"true"}>
            <ProfileCard
              name={full_name}
              email={email}
              phone={mobile_number}
              profilePic={profile_img}
              handleUpload={handleUpload}
              isLoading={isLoadingPic}
            />
          </MyProfileContainer>

          <MyProfileContainer
            title={"Customer View"}
            className="mt-5"
            pic={false}
            cv={true}
          >
            <InputElement
              label={"Name"}
              type=""
              name="full_name"
              onChange={(e) => handleChange(e)}
              value={profileformdata.full_name}
            />
            <InputElement
              label={"Email"}
              type=""
              name="email"
              onChange={handleChange}
              value={profileformdata.email}
            />
            <InputElement
              label={"Phone"}
              type=""
              name="mobile_number"
              onChange={handleChange}
              value={profileformdata.mobile_number}
            />

            <SelectBox
              label={"Customer Type"}
              type=""
              name="customertype"
              ItemsMenu={ItemsMenuCusType}
            />

            <InputElement
              label={"Firm Name"}
              type=""
              name="firmname"
              onChange={(e) => handleChange(e)}
              className="mt-5"
            />
            <InputElement label={"PAN"} type="" name="pan" className="mt-5" />
            <SelectBox
              label={"GST Treatment"}
              className={"mt-5"}
              type=""
              name="customertype"
              ItemsMenu={ItemsMenuGst}
            />
            <InputElement
              label={"GSTIN"}
              type=""
              name="phone"
              className="mt-5"
              error={false}
            />
          </MyProfileContainer>

          <MyProfileContainer
            title={"Billing Address"}
            className="mt-5"
            pic={false}
            cv={true}
          >
            <InputElement
              label={"Address Line 1"}
              type=""
              name="address"
              onChange={handleChange}
              value={profileformdata.address}
            />
            <InputElement label={"PIN"} type="" name="pin" />
            <InputElement label={"State"} type="" name="district" />

            <InputElement
              label={"State"}
              type=""
              name="firmname"
              className=""
            />

            <div className="w-full mt-2">
              <div className="card-title">Shipping Address</div>
            </div>
            <InputElement
              label={"Address Line 1"}
              className={"mt-3"}
              type=""
              name="address1"
            />
            <InputElement label={"PIN"} type="" name="pin" className={"mt-3"} />
            <InputElement
              label={"State"}
              type=""
              name="district"
              className={"mt-3"}
            />

            <InputElement
              label={"State"}
              type=""
              name="firmname"
              className={"mt-3"}
            />
          </MyProfileContainer>

          <MyProfileContainer
            title={"KYC Documents"}
            className="mt-5"
            pic={false}
            cv={true}
            isKyc={true}
          >
            <InputFile
              label={"GST Certificate"}
              type=""
              name="gst_cert"
              isFile={true}
            />
            <InputFile label={"Aadhaar"} type="" name="aadhaar" isFile={true} />
            <InputFile
              label={"PAN"}
              type=""
              name="pancard"
              isFile={true}
              className={"mt-2"}
            />

            <InputFile
              label={"Bank Document"}
              type=""
              name="bank_doc"
              className="mt-2"
              isFile={true}
            />
          </MyProfileContainer>
        </div>

        <div className="w-full flex justify-end mb-8">
          <div className="w-2/7 flex justify-between">
            <Button
              sx={{
                width: "85%",
                textTransform: "capitalize",
                width: "147px",
                color: "#E10505",
                border: "1px solid #E10505",
              }}
              variant="outlined"
              color="error"
            >
              Cancel
            </Button>
            <Button
              sx={{
                width: "85%",
                marginLeft: "10px",
                textTransform: "capitalize",
                width: "147px",
                color: "#1550A1",
                border: "1px solid #1550A1",
              }}
              variant="outlined"
              type="submit"
            >
              {loading ? (
                <CircularProgress sx={{ color: "blue" }} size={20} />
              ) : (
                "Update"
              )}
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default MyProfile;
